<template>
    <div class="formDocs" v-loading.fullscreen.lock="fullscreenLoading">
		<a href="https://www.ideal360.fr"><img style="width: 250px;" src="https://aloha.crm-ideal.fr/img/logo-ideal-solutions-hor.png" alt="logo Ideal360"/></a>
		<template v-if="!fullscreenLoading">
			<el-form class="formIban" ref="form" :model="form">
				<el-form-item class="nomBanque" required="true" label="Nom de la banque">
					<el-input class="inputNom" v-model="form.banque"></el-input>
				</el-form-item>
				<el-form-item class="titulaireInput" required="true" label="Titulaire du compte">
					<el-input class="inputTitulaire" v-model="form.titulaire"></el-input>
				</el-form-item>
				<el-form-item class="domiciliationInput" required="true" label="Domiciliation du compte">
					<el-input class="inputDomiciliation" v-model="form.domiciliation"></el-input>
				</el-form-item>
				<el-form-item class="addressInput" required="true" label="Adresse du propriétaire du compte">
					<el-input class="inputAddress" v-model="form.adresse"></el-input>
				</el-form-item>
				<el-form-item class="ibanInputs" required="true" label="IBAN">
					<el-input class="ibanInput" v-model="form.iban" ref="iban" minlength="14" maxlength="27"></el-input>
					<!-- <el-input class="ibanInput" @input="val => moveToNextIban(val, $refs.iban2, 4)" v-model="form.iban1" ref="iban1" minlength="4" maxlength="4"></el-input>
					<el-input class="ibanInput" @input="val => moveToNextIban(val, $refs.iban3, 4)" v-model="form.iban2" ref="iban2" minlength="4" maxlength="4"></el-input>
					<el-input class="ibanInput" @input="val => moveToNextIban(val, $refs.iban4, 4)" v-model="form.iban3" ref="iban3" minlength="4" maxlength="4"></el-input>
					<el-input class="ibanInput" @input="val => moveToNextIban(val, $refs.iban5, 4)" v-model="form.iban4" ref="iban4" minlength="4" maxlength="4"></el-input>
					<el-input class="ibanInput" @input="val => moveToNextIban(val, $refs.iban6, 4)" v-model="form.iban5" ref="iban5" minlength="4" maxlength="4"></el-input>
					<el-input class="ibanInput" @input="val => moveToNextIban(val, $refs.iban7, 4)" v-model="form.iban6" ref="iban6" minlength="4" maxlength="4"></el-input>
					<el-input class="ibanInput" v-model="form.iban7" ref="iban7" minlength="3" maxlength="3"></el-input> -->
				</el-form-item>
				<el-form-item class="bicInput" required="true" label="BIC">
					<el-input class="inputBic" v-model="form.bic" minlength="8" maxlength="11"></el-input>
				</el-form-item>
				<el-upload
					required="true"
					class="upload-demo"
					:on-preview="handlePreview"
					:on-remove="handleRemove"
					:before-remove="beforeRemove"
					:on-change="handleChange"
					:before-upload="beforeUpload"
					multiple
					:limit="1"
					:on-exceed="handleExceed"
					:file-list="fileList"
					accept=".jpg,.jpeg,.png,.gif,.bmp,.webp,.pdf"
					:auto-upload="false">
					<el-button size="small" type="primary">Charger le RIB</el-button>
					<div slot="tip" class="el-upload__tip">Fichiers jpg/png</div>
				</el-upload>
				<el-form-item class="submitAction">
					<el-button type="primary" @click.prevent="onSubmit" :disabled="!formValidate">Créer</el-button>
					<el-button @click.prevent="resetData">Effacer</el-button>
				</el-form-item>
			</el-form>
		</template>
		<template v-else>
			<el-row type="flex" justify="center">
				<el-col :span="24">
					<el-alert
						title="Veuillez patienter"
						description="Nous vérifions vos informations"
						type="info"
						center
					/>
				</el-col>
			</el-row>
		</template>	
    </div>
</template>

<script>
var moment = require('moment');
import { onBeforeMount } from 'vue';
import scriptDocumentsLegaux from '../../../script/script_documentsLegaux.js';
function initValue(){
    return {
		fullscreenLoading:true,
		form: {
			banque: '',
			iban: '',
			titulaire: '',
			adresse: '',
			domiciliation: '',
			iban1: '',
			iban2: '',
			iban3: '',
			iban4: '',
			iban5: '',
			iban6: '',
			iban7: '',
			bic: '',
		},
		fileList: [],
	}
}
export default {
	data () {
		return initValue()
	},
	methods: {
		handleRemove() {
			this.fileList = [];
		},
		handlePreview(file) {
			console.log(file);
		},
		handleExceed(files) {
			this.$message.warning(`La limite est 1, vous avez choisi ${files.length} fichiers.`);
		},
		beforeRemove(file) {
			return this.$confirm(`Supprimer le transfert de ${ file.name } ?`);
		},
		handleChange(file, fileList) {
			this.fileList = fileList.slice(-3);
		},
		checkBeforeSubmit: scriptDocumentsLegaux.checkBeforeSubmit,
		sendAllInfos: scriptDocumentsLegaux.sendAllInfos,
		async onSubmit(){
			await this.sendAllInfos(this.source, this.id, this.securekey, this.form, this.fileList)
		},
		resetData(){
			Object.assign(this.$data, initValue())
		},
		beforeUpload(file) {
			const isImage = file.type.startsWith('image/');
			const isPDF = file.type === 'application/pdf';
			if (!isImage && !isPDF) {
				this.$message.error('Seules les images et les fichiers PDF sont autorisés !');
				return false; // Bloque le téléchargement
			}
			return true; // Autorise le téléchargement
		},
		moveToNextIban(value, nextRef, maxLength) {
			if (value && value.length >= maxLength) {
				nextRef.focus()
			}
		}
    },
	computed:{
		source(){
			return this.$route.params.source
		},
		id(){
			return this.$route.params.id
		},
		securekey(){
			return this.$route.params.securekey
		},
		formValidate(){
			if(this.form.banque.length && this.form.iban.length == 27 && this.form.bic.length > 7 && this.fileList.length > 0 && this.form.titulaire.length > 0){
				return true
			}else{
				return false
			}
		}
	},
	created: async function(){
		await scriptDocumentsLegaux.checkBeforeSubmit(this.source, this.id, this.securekey)
		this.fullscreenLoading = false
	},
	mounted: async function(){
		// await this.checkBeforeSubmit(this.source, this.id, this.securekey)
	},
	watch: {
		"form.banque": function(value) {
			if (value)
				this.form.banque = value.toUpperCase()
		},
		"form.domiciliation": function(value) {
			if (value)
				this.form.domiciliation = value.toUpperCase()
		},
		"form.adresse": function(value) {
			if (value)
				this.form.adresse = value.toUpperCase()
		},
		"form.bic": function(value) {
			if (value)
				this.form.bic = value.toUpperCase()
		},
		"form.iban1": function(value) {
			if (value)
				this.form.iban1 = value.toUpperCase()
		},
		"form.iban2": function(value) {
			if (value)
				this.form.iban2 = value.toUpperCase()
		},
		"form.iban3": function(value) {
			if (value)
				this.form.iban3 = value.toUpperCase()
		},
		"form.iban4": function(value) {
			if (value)
				this.form.iban4 = value.toUpperCase()
		},
		"form.iban5": function(value) {
			if (value)
				this.form.iban5 = value.toUpperCase()
		},
		"form.iban6": function(value) {
			if (value)
				this.form.iban6 = value.toUpperCase()
		},
		"form.iban7": function(value) {
			if (value)
				this.form.iban7 = value.toUpperCase()
		},
		"form.iban": function(value) {
			if (value)
				this.form.iban = value.toUpperCase()
		},
		"form.titulaire": function(value) {
			if (value)
				this.form.titulaire = value.toUpperCase()
		},
	}
}
</script>

<style>
.formDocs{
	display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
	align-items: center;
}
.formIban{
	width: 70vw;
}
@media screen and (min-width: 601px) {
	.formIban{
		width: 50vw;
	}
}
.ibanInputs > .el-form-item__content{
	display: flex;
}

.ibanInput{
	width: 100%;
}

.inputNom{
	width: 100%;
}

.inputBic{
	width: 100%;
}

.inputTitulaire{
	width: 100%;
}

.inputDomiciliation{
	width: 100%;
}

.inputAddress{
	width: 100%;
}

.btnGenerateCsv{
	margin-left: .5em;
}
.upload-demo{
	display: flex;
    align-items: center;
    justify-content: center;
    align-content: center;
    flex-direction: column;
}
.submitAction{
	display: flex;
    align-items: center;
    justify-content: center;
    align-content: center;
    flex-direction: column;
	text-align: center;
}
.submitAction > .el-form-item__content{
	margin-left: 0 !important;
}

.formIban .el-form-item{
	display: flex;
	flex-direction: column;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
}

.formIban .el-form-item__content{
	width: 100%;
}
.formIban .el-form-item__label{
	text-align: left;
	width: 100%;
}
</style>